<div [ngSwitch]="optionsType">
  <div class="options dropdown-options"
      *ngSwitchCase="1"
      [ngStyle]="{'max-height': maxHeight, 'max-width': maxWidth}"
      [ngClass]="optionsPosition ? optionsPosition : ''"
      infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      [scrollWindow]="false"
      (scrolled)="onModalScrollDown()">
      <div *ngFor="let item of listItems; let index=index"
           [id]="'dropdown-item-' + item[optionValueField]"
           [ngStyle]="{
             'background': highlightSelectedValue && (value && item ? value[optionValueField] === item[optionValueField] : false) && !item.isHeader ? '#9ed7ff' : '',
             'color': item['overrideColor'] ? item['overrideColor'] : ''
           }"
           class="text-truncate d-flex"
           (click)="setValue(item)"
           [ngClass]="{
             'header-hover': item.isHeader,
             'no-fonts-hover': item[optionLabelField] === 'No fonts added'
           }">
        <span *ngIf="item['icon']" style="color: #5E6980;" [ngClass]="item['icon'] ? item['icon'] + ' icon-block' : ''"></span>

        <span *ngIf="item[optionLabelField] === 'No fonts added'"
              class="dropdown-header header-box pl-0 header-nfa">
          {{item[optionLabelField]}}
        </span>
        <span *ngIf="!item.isHeader && item[optionLabelField] !== 'No fonts added'"
              class="d-flex hoverable-span" [ngStyle]="{'opacity': item['isPremium'] && item['isPremium'] === true ? 0.5 : 1}">
            {{item[optionLabelField]}}
            <span class="float-right left-detail">{{item[optionSecondaryLabelField]}}</span>
        </span>
        <span *ngIf="item.isHeader"
          class="dropdown-header header-box pl-0 header-prop">
          {{item[optionLabelField]}}
        </span>
        <span *ngIf="item['isPremium'] && item['isPremium'] === true" class="ml-3"><i class="fas fa-crown premium-icon"></i></span>
      </div>

  <div *ngIf="isFetchingData" class="d-flex justify-content-center align-items-center">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
    </div>
  </div>
</div>



  <div class="options dropdown-options"
      *ngSwitchCase="2"
      [ngStyle]="{'max-height': maxHeight, 'max-width': maxWidth}"
      [ngClass]="optionsPosition ? optionsPosition : ''"
      infiniteScroll
      [infiniteScrollDistance]="3"
      [infiniteScrollThrottle]="300"
      [scrollWindow]="false"
      (scrolled)="onModalScrollDown()">
    <div *ngIf="optionsHeaderText" class="dropdown-header header-box">{{optionsHeaderText}}</div>
    <div *ngFor="let item of listItems; trackBy: trackByFn" class="text-truncate"
         [id]="'dropdown-item-' + item[optionValueField]"
         [ngStyle]="
       {'background': highlightSelectedValue && (value && item ? value[optionValueField] === item[optionValueField] : false)  ? '#9ed7ff' : '',
       'color': item['overrideColor'] ? item['overrideColor'] : ''}"
         (click)="setValue(item)">
      <span class="text-primary font-weight-600" [attr.title]="item[optionLabelFieldTooltip]"  *ngIf="value[optionValueField] === item[optionValueField]">{{item[optionLabelField]}}
        <i class="ml-2 fas fa-check"></i>
        <span class="float-right left-detail">{{item[optionSecondaryLabelField]}}</span>
      </span>
      <span [attr.title]="item[optionLabelFieldTooltip]"  *ngIf="value[optionValueField] !== item[optionValueField]">{{item[optionLabelField]}}
        <span class="float-right left-detail">{{item[optionSecondaryLabelField]}}</span>
      </span>
      <span *ngIf="item['isPremium'] && item['isPremium'] === true" class="ml-3"><i class="fas fa-crown premium-icon"></i></span>
    </div>
    <div *ngIf="isFetchingData" class="d-flex justify-content-center align-items-center">
      <div class="spinner-border spinner-border-sm text-primary" role="status">
      </div>
    </div>
  </div>

  <ng-container *ngSwitchCase="3">
    <div class="options-type-3 dropdown-options-type-3">
      <div style="overflow: scroll; padding: 0px" [ngStyle]="{'max-height': maxHeight, 'max-width': maxWidth}"
           [ngClass]="optionsPosition ? optionsPosition : ''"
           infiniteScroll
           [infiniteScrollDistance]="2"
           [infiniteScrollThrottle]="50"
           [scrollWindow]="false"
           (scrolled)="onModalScrollDown()"
      >
        <div *ngFor="let item of listItems; let index=index"
             [id]="'dropdown-item-' + item[optionValueField]"
             [ngStyle]="{
             'background': highlightSelectedValue && (value && item ? value[optionValueField] === item[optionValueField] : false) && !item.isHeader ? '#9ed7ff' : '',
             'color': item['overrideColor'] ? item['overrideColor'] : ''
           }"
             class="text-truncate d-flex each-option"
             (click)="setValue(item)"
             [ngClass]="{
             'header-hover': item.isHeader,
             'no-fonts-hover': item[optionLabelField] === 'No fonts added'
           }">
          <span *ngIf="item['icon']" style="color: #5E6980;" [ngClass]="item['icon'] ? item['icon'] + ' icon-block' : ''"></span>

          <span *ngIf="item[optionLabelField] === 'No fonts added'"
                class="dropdown-header header-box pl-0 header-nfa">
          {{item[optionLabelField]}}
        </span>
          <span *ngIf="!item.isHeader && item[optionLabelField] !== 'No fonts added'"
                class="d-flex hoverable-span" [ngStyle]="{'opacity': item['isPremium'] && item['isPremium'] === true ? 0.5 : 1}">
            {{item[optionLabelField]}}
            <span class="float-right left-detail">{{item[optionSecondaryLabelField]}}</span>
        </span>
          <span *ngIf="item.isHeader"
                class="dropdown-header header-box pl-0 header-prop">
          {{item[optionLabelField]}}
        </span>
          <span *ngIf="item['isPremium'] && item['isPremium'] === true" class="ml-3"><i class="fas fa-crown premium-icon"></i></span>
        </div>

        <div *ngIf="isFetchingData" class="d-flex justify-content-center align-items-center">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
          </div>
        </div>
      </div>

      <div class="sticky-cta" (click)="stickyCTAClicked.emit($event)">{{stickyCTAText}}</div>
    </div>
  </ng-container>
</div>
